var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "d-flex flex-column",
      attrs: {
        height: "100%"
      }
    },
    [
      _c("gg-card-header", [_vm._v(" Upgrade Your Account ")]),
      _c("gg-card-text", [
        _vm._v(
          " Upgrading your service can increase your available resources. Click the button below to contact our Sales Team regarding a possible upgrade. "
        )
      ]),
      _c(
        "v-card-actions",
        {
          staticClass: "justify-end mt-auto pa-4"
        },
        [
          _c(
            "gg-btn",
            {
              attrs: {
                to: {
                  name: "support_ticketnew",
                  query: {
                    d: "Sales",
                    s: _vm.alert.serviceID,
                    sbj: _vm.subject
                  }
                }
              }
            },
            [_vm._v(" Upgrade Your Account ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }